import { isFileAccepted } from './accept';
import type { UploadMessages } from './types';

/**
 * Validate a file against type and size constraints. Returns the caller's own error
 * string, or null. The copy belongs to the upload zone (`UploadPreset.messages`),
 * never to this function — see ticket 118752.
 */
export function validateFile(
  file: File,
  opts: { accept?: string; maxSizeMb?: number; messages: UploadMessages },
): string | null {
  if (!isFileAccepted(file, opts.accept)) return opts.messages.invalidType;
  if (opts.maxSizeMb && file.size > opts.maxSizeMb * 1024 * 1024) return opts.messages.tooLarge;
  return null;
}
